/**
 * Resolves the node whose artwork represents a node's category — the category
 * level ancestor (level 1 when the tree has a single root, otherwise level 0).
 * Falls back to the node itself when the ancestor can't be resolved.
 */
export function getCategoryIconNode(node, allNodes = []) {
  if (!node || !allNodes.length) return node;

  // Build a map for faster lookups
  const nodeMap = new Map();
  for (let i = 0; i < allNodes.length; i++) {
    nodeMap.set(allNodes[i].id, allNodes[i]);
  }

  // Determine category level (1 if single root at level 0, otherwise 0)
  const hasSingleRoot = allNodes.filter(n => n.level === 0).length === 1;
  const categoryLevel = hasSingleRoot ? 1 : 0;

  // If this node IS the category, or is the root, use its own art
  if (node.level === categoryLevel || node.level === 0) return node;

  // Walk up to the category ancestor
  let current = node;
  while (current && current.parentId) {
    const parent = nodeMap.get(current.parentId);
    if (!parent) break;
    if (parent.level === categoryLevel) return parent;
    current = parent;
  }

  return node;
}
